"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("../index.vue");
var _ForgotForm = _interopRequireDefault(require("./ForgotForm.vue"));
var _LoginProfessional = _interopRequireDefault(require("./LoginProfessional.vue"));
var SignUpForm = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(SignUpForm, _Vue);
  var _super = (0, _createSuper2.default)(SignUpForm);
  function SignUpForm() {
    var _this;
    (0, _classCallCheck2.default)(this, SignUpForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showPass", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visibleForgot", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "StatusPage", _index.StatusPage);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "phoneValid", false);
    return _this;
  }
  (0, _createClass2.default)(SignUpForm, [{
    key: "handlePhoneNumber",
    value: function handlePhoneNumber(ev) {
      this.phoneValid = ev.isValid;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {}
  }]);
  return SignUpForm;
}(_vuePropertyDecorator.Vue);
SignUpForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    LoginProfessional: _LoginProfessional.default,
    ForgotForm: _ForgotForm.default
  }
})], SignUpForm);
var _default = SignUpForm;
exports.default = _default;